import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastService } from '../../../../@theme/service/toast.service';
import { Objects } from '../../../util/objects';

@Component({
  selector: 'ngx-file-instance-search-link-column',
  template: ` <nb-icon class="mr-1" *ngIf="useSearch && params.value" style="cursor: pointer" icon="search-outline" status="primary" (click)="onClickSearch()"></nb-icon>
                <span [class.file-instance-search-link-color]="useLinkColor && instanceId" [class.pointer]="instanceId" (click)="onClickLink()">{{ params.value }}</span>
               `,
  styles: [`
    .file-instance-search-link-color {
      font-weight: bold;
      color: #00d68f;
    }
  `],
  encapsulation: ViewEncapsulation.None,
})
export class FileInstanceSearchWithLinkComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public data: any;
  public useSearch: boolean = false;
  public useLinkColor: boolean = false;
  public instanceId: string;

  constructor(private router: Router, private toast: ToastService) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.data = this.params.data;
    this.useSearch = Objects.parseBoolean(Objects.safeGetValue(this.params, 'useSearch', 'false'));
    this.useLinkColor = Objects.parseBoolean(Objects.safeGetValue(this.params, 'useLinkColor', 'false'));
    this.instanceId = this.params.hasOwnProperty('instanceIdPath') ? this.data[this.params['instanceIdPath']] : this.data.instanceId;
  }

  ngOnInit() {}

  onClickSearch(): void {
    this.params.context.setFilter('instanceId', this.data.instanceId);
  }

  onClickLink(): void {
    console.debug(this.instanceId);

    if (!this.instanceId) return;
  }
}
